<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>dynamic_feed</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Manejo de Liquidaciones a Comercios</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-tabs v-model="currentTab">
          <v-tab v-if="checkCanAccess('ap-puede-generar-liquidacion')">
            <v-icon>search</v-icon>
            Selección de Créditos para Nueva Liquidacion
          </v-tab>
          <v-tab v-if="checkCanAccess('ap-puede-marcar-no-pagar')">
            <v-icon>assignment</v-icon>
            Créditos con Marca de No Pagar
          </v-tab>
          <v-tab>
            <v-icon>assignment</v-icon>
            Liquidaciones Generadas
          </v-tab>

          <v-tab-item v-if="checkCanAccess('ap-puede-generar-liquidacion')">
            <v-card flat>
              <v-card-text>
                <v-row dense>
                  <v-col cols="3">
                    <v-autocomplete
                      v-model="filtro.empresaId"
                      :items="empresas"
                      autocomplete="disabled"
                      item-text="nombre"
                      item-value="id"
                      label="Créditos de la Empresa"
                      placeholder="Seleccione una"
                      :menu-props="{ minWidth: '400' }"
                    ></v-autocomplete>
                  </v-col>
                  <v-col>
                    <v-autocomplete
                      v-model="filtro.canalesVenta"
                      :items="canalesVentaFiltradosPorEmpresa"
                      autocomplete="disabled"
                      multiple
                      clearable
                      item-text="nombre"
                      item-value="id"
                      label="Originadas en"
                      placeholder="Seleccione un Canal de Venta (dejar en blanco para Todos)"
                      :menu-props="{ minWidth: '400' }"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row align="center" dense>
                  <v-col>
                    <v-autocomplete
                      v-model="filtro.productoId"
                      :items="productos"
                      autocomplete="disabled"
                      item-text="descripcion"
                      item-value="id"
                      label="Del producto"
                      placeholder="Seleccione uno"
                      :menu-props="{ minWidth: '400' }"
                    ></v-autocomplete>
                  </v-col>
                  <v-col>
                    <v-autocomplete
                      v-model="filtro.grupoComercialId"
                      :items="gruposComerciales"
                      autocomplete="disabled"
                      item-text="nombre"
                      item-value="id"
                      label="Del Grupo Comercial"
                      placeholder="Seleccione uno"
                      :menu-props="{ minWidth: '400' }"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="2">
                    <v-select
                      :items="diasSemana"
                      v-model="filtro.diaALiquidar"
                      item-text="descripcion"
                      item-value="id"
                      label="Día a Liquidar"
                      placeholder="Seleccione uno"
                      :menu-props="{ minWidth: '400' }"
                    ></v-select>
                    <!-- <app-selector-periodos v-on:update-periodo="filtro.periodo = $event"></app-selector-periodos> -->
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2">
                    <v-btn
                      color="success"
                      @click="getItems(true)"
                      :disabled="loading"
                      >Consultar</v-btn
                    >
                  </v-col>
                </v-row>

                <v-flex>
                  <v-card dense>
                    <v-toolbar
                      dense
                      :color="$store.state.UiColors.crudToolbarList"
                    >
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light"
                        >Lista</v-toolbar-title
                      >
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-data-table
                      loading-text="Buscando registros"
                      dense
                      :headers="headers"
                      :items="records"
                      :rows-per-page="pagination.itemsPerPage"
                      :options.sync="pagination"
                      v-model="selectedCreditos"
                      :loading="loading"
                      class="elevation-1"
                      :footer-props="footer"
                      :show-select="records.length > 0"
                      item-key="id"
                    >
                      <template v-slot:header.data-table-select="{ on, props }">
                        <v-checkbox
                          @change="selectAllChanged"
                          color="purple"
                          v-bind="props"
                          v-on="on"
                        ></v-checkbox>
                      </template>

                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron registros con los filtros ingresados
                        </v-alert>
                      </template>

                      <template v-slot:item="{ item, isSelected, select }">
                        <tr>
                          <td>
                            <v-simple-checkbox
                              class="caption"
                              color="green"
                              :value="isSelected"
                              @input="select($event)"
                            ></v-simple-checkbox>
                          </td>
                          <td>
                            <app-acciones-comunes
                              :personaId="item.solicitanteId"
                              :documento="item.documento"
                            >
                            </app-acciones-comunes>
                          </td>

                          <td class="text-xs-left caption">
                            {{ item.origen }}
                          </td>
                          <td class="text-xs-left caption">
                            {{ item.producto }}
                          </td>
                          <td class="text-xs-left caption">
                            {{ item.grupoComercial }}
                          </td>
                          <td class="text-xs-left caption">{{ item.cuil }}</td>
                          <td class="text-xs-left caption">
                            {{ item.solicitante }}
                          </td>
                          <td class="text-xs-left caption">
                            {{ item.monto | currency }}
                          </td>
                          <td class="text-xs-left caption">
                            {{
                              item.fechaIngreso
                                | dateParse()
                                | dateFormat('DD-MM-YYYY')
                            }}
                          </td>
                          <td class="text-xs-left caption">
                            <v-chip
                              small
                              :color="item.empresaColor"
                              label
                              dark
                              >{{ item.empresaShort }}</v-chip
                            >
                          </td>
                          <td>
                            <!-- Para los casos con estado UC Confirmado-->
                            <v-tooltip
                              bottom
                              v-if="item.estadoTransferenciaId == 2"
                            >
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  small
                                  color="red"
                                  @click="quitarItem(item)"
                                  v-on="on"
                                  >clear</v-icon
                                >
                              </template>
                              Quitar caso de la lista de transferencias
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-card-text>
              <v-card-actions>
                <v-container fluid>
                  <v-layout v-if="selectedCreditos.length > 0">
                    <v-row>
                      <v-col>
                        <v-switch
                          v-model="filtro.conDesglose"
                          label="Con Desglose"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-switch
                          v-model="filtro.definitiva"
                          label="Definitiva"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-switch
                          disabled
                          v-model="filtro.generarEgresoPorTransferencia"
                          label="Generar Egreso por Transferencia"
                        ></v-switch>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col>
                        <v-btn
                          color="success"
                          @click="procesar()"
                          :disabled="loading"
                        >
                          Generar Liquidación
                        </v-btn>
                      </v-col>

                      <v-col v-if="checkCanAccess('ap-puede-marcar-no-pagar')">
                        <v-btn
                          color="success"
                          @click="marcarNoPagar()"
                          :disabled="loading"
                        >
                          Marcar No Pagar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-tab-item>

          <!-- Creditos con marca de no pagar -->
          <v-tab-item>
            <creditos-marca-no-pagar></creditos-marca-no-pagar>
          </v-tab-item>

          <!-- Liquidaciones Generadas -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-row dense>
                  <v-col cols="3">
                    <v-autocomplete
                      v-model="filtroLiquidaciones.empresaId"
                      :items="empresas"
                      autocomplete="disabled"
                      item-text="nombre"
                      item-value="id"
                      label="Liquidaciones de la Empresa"
                      placeholder="Seleccione una"
                      :menu-props="{ minWidth: '400' }"
                    ></v-autocomplete>
                  </v-col>
                  <v-col>
                    <v-autocomplete
                      v-model="filtroLiquidaciones.canalesVenta"
                      :items="canalesVentaFiltradosPorEmpresa"
                      autocomplete="disabled"
                      multiple
                      clearable
                      item-text="nombre"
                      item-value="id"
                      label="Del Canal"
                      placeholder="Seleccione un Canal de Venta (dejar en blanco para Todos)"
                      :menu-props="{ minWidth: '400' }"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row align="center" dense>
                  <v-col>
                    <v-autocomplete
                      v-model="filtroLiquidaciones.grupoComercialId"
                      :items="gruposComerciales"
                      autocomplete="disabled"
                      item-text="nombre"
                      item-value="id"
                      label="Del Grupo Comercial"
                      placeholder="Seleccione uno"
                      :menu-props="{ minWidth: '400' }"
                    ></v-autocomplete>
                  </v-col>

                  <v-col>
                    <v-select
                      v-model="filtroLiquidaciones.estadoId"
                      :items="tiposEstadoLiquidacion"
                      autocomplete="disabled"
                      item-text="descripcion"
                      item-value="id"
                      label="En Estado"
                      placeholder="Seleccione uno"
                      :menu-props="{ minWidth: '400' }"
                    ></v-select>
                  </v-col>

                  <v-col cols="2">
                    <app-selector-periodos
                      v-on:update-periodo="filtroLiquidaciones.periodo = $event"
                    ></app-selector-periodos>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2">
                    <v-btn
                      color="success"
                      @click="getLiquidaciones(true)"
                      :disabled="loading"
                      >Consultar</v-btn
                    >
                  </v-col>
                </v-row>

                <v-flex>
                  <v-card dense>
                    <v-toolbar
                      dense
                      :color="$store.state.UiColors.crudToolbarList"
                    >
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light"
                        >Lista</v-toolbar-title
                      >
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-data-table
                      loading-text="Buscando registros"
                      dense
                      :headers="headersLiquidaciones"
                      :items="recordsLiquidaciones"
                      :rows-per-page="paginationLiquidaciones.itemsPerPage"
                      :options.sync="paginationLiquidaciones"
                      :server-items-length="totalItemsLiquidaciones"
                      :loading="loading"
                      class="elevation-1"
                      :footer-props="footerLiquidaciones"
                      item-key="id"
                      v-model="selectedLiquidaciones"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron registros con los filtros ingresados
                        </v-alert>
                      </template>

                      <template v-slot:item="{ item, isSelected, select }">
                        <tr>
                          <td>
                            <v-simple-checkbox
                              class="caption"
                              color="green"
                              :value="isSelected"
                              @input="select($event)"
                            ></v-simple-checkbox>
                          </td>
                          <td class="text-xs-left caption">
                            {{ item.numero }}
                          </td>
                          <td class="text-xs-left caption">
                            {{
                              item.fecha
                                | dateParse()
                                | dateFormat('DD-MM-YYYY')
                            }}
                          </td>
                          <td class="text-xs-left caption">
                            {{ item.canalVenta }}
                          </td>
                          <td class="text-xs-left caption">
                            {{ item.grupoComercial }}
                          </td>
                          <td class="text-xs-left caption">
                            {{ item.importe | currency }}
                          </td>
                          <td class="text-xs-left caption">
                            {{ item.estado }}
                          </td>
                          <td class="text-xs-left caption">
                            {{ item.medioPago }}
                          </td>
                          <td class="text-xs-left caption">
                            <v-chip
                              small
                              :color="item.empresaColor"
                              label
                              dark
                              >{{ item.empresaShort }}</v-chip
                            >
                          </td>
                          <td>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click.stop="imprimirDetalleLiquidacion(item)"
                                  color="green"
                                  x-small
                                  dark
                                  fab
                                  v-on="on"
                                >
                                  <v-icon>print</v-icon>
                                </v-btn>
                              </template>
                              Imprimir Detalle
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-card-text>
              <v-card-actions>
                <v-container fluid>
                  <v-layout>
                    <v-row>
                      <v-col
                        v-if="
                          selectedLiquidaciones.length > 0 &&
                            checkCanAccess('ap-puede-anular-liquidacion')
                        "
                      >
                        <v-btn
                          color="success"
                          @click="anular()"
                          :disabled="loading"
                        >
                          Anular
                        </v-btn>
                      </v-col>
                      <v-col v-if="puedeConfirmarPreliquidaciones">
                        <v-btn
                          color="success"
                          @click="confirmarPreliquidacion()"
                          :disabled="loading"
                        >
                          Pasar a Definitiva
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click="procesarReporte"
                    >Generar Reporte</v-btn
                  >
                </v-card-actions>
              </v-card-actions>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>

    <app-loading :loading="saving"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ filtro }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import { http } from '@/axios';

import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

import CreditosMarcaNoPagar from './CreditosMarcaNoPagar.vue';

const diasSemana = [
  { id: 1, descripcion: 'Lunes' },
  { id: 2, descripcion: 'Martes' },
  { id: 3, descripcion: 'Miércoles' },
  { id: 4, descripcion: 'Jueves' },
  { id: 5, descripcion: 'Viernes' },
];

export default {
  components: {
    CreditosMarcaNoPagar,
  },
  data() {
    return {
      saving: false,
      downloading: false,
      primeraBusquedaRealizada: false,
      loading: false,
      editMode: false,
      suspend: false,
      filterChanged: false,
      search: '', // valor para búsqueda
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
      },
      paginationLiquidaciones: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 20, 50],
        showCurrentPage: true,
      },
      footerLiquidaciones: {
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 20, 50],
        showCurrentPage: true,
      },
      totalItems: 0, // va afuera de pagination
      totalItemsLiquidaciones: 0, // va afuera de pagination
      headers: [
        // definición de columnas
        { text: 'Ver', value: 'accion', width: 80, sortable: false },
        { text: 'Origen del Crédito', value: 'origen' },
        { text: 'Producto', value: 'producto' },
        { text: 'Grupo Comer.', value: 'grupoComercial' },
        { text: 'Cuil', value: 'cuil' },
        { text: 'Solicitante del Crédito', value: 'solicitante' },
        { text: 'Monto', value: 'monto', width: 130 },
        { text: 'Fecha de Ingreso', value: 'fechaIngreso' },
        { text: 'Empresa', value: 'empresaNombre', width: 100 },
        { text: '', value: '', width: 100, sortable: false },
      ],
      headersLiquidaciones: [
        // definición de columnas
        { text: '', value: '', sortable: false },
        { text: 'Numero', value: 'numero' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Canal Venta', value: 'canalVenta' },
        { text: 'Grupo Comercial', value: 'grupoComercial' },
        { text: 'Importe', value: 'importe' },
        { text: 'Estado', value: 'estado' },
        { text: 'Pago por', value: 'medioPago' },
        { text: 'Empresa', value: 'empresaNombre', width: 100 },
        { text: '', value: '', width: 100, sortable: false },
      ],
      records: [], // registros
      recordsLiquidaciones: [], // registros
      currentTab: null,
      selectedCreditos: [],
      selectedLiquidaciones: [],
      filtro: {
        definitiva: true,
        empresaId: 1,
        canalesVenta: null,
        productoId: 0,
        grupoComercialId: 0,
        diaALiquidar: 0,
        cajaId: 0,
        conDesglose: false,
        generarEgresoPorCaja: false,
        generarEgresoPorTransferencia: true,
      },
      filtroLiquidaciones: {
        empresaId: 1,
        canalVentaId: 0,
        grupoComercialId: 0,
        estadoId: 0,
        periodo: { id: 1 },
      },
      canalesVenta: [],
      empresas: [],
      productos: [],
      gruposComerciales: [],
      cajas: [],
      tiposEstadoLiquidacion: [],
      diasSemana: diasSemana,
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadGruposComerciales();
    this.loadCanalesVenta();
    this.loadProductos();
    this.loadCajas();
    this.loadTiposEstadoLiquidacion();
    this.setDiaALiquidar();
  },
  watch: {
    pagination: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getItems(false);
      },
      deep: true,
    },
    paginationLiquidaciones: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getLiquidaciones();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['getActionFromLink', 'user', 'checkCanAccess']),
    action: function() {
      return this.getActionFromLink(this.$route.path);
    },
    canalesVentaFiltradosPorEmpresa: function() {
      if (!this.canalesVenta || this.filtro.empresaId == 0) return null;
      return this.canalesVenta.filter(
        (c) =>
          c.empresaId == this.filtro.empresaId &&
          c.tipoCanalVentaDescripcion === 'Comercio'
      );
    },
    puedeConfirmarPreliquidaciones: function() {
      if (this.selectedLiquidaciones.length > 0) {
        var noCorresponden = this.selectedLiquidaciones.find(
          (x) => x.estado != 'Pre-Liquidación'
        );
        if (!noCorresponden) return true;
      }
      return false;
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    selectAllChanged(toggle) {
      this.selectedCreditos = [];
      if (toggle) {
        for (let index = 0; index < this.records.length; index++) {
          const element = this.records[index];

          this.selectedCreditos.push(element);
        }
      }
    },
    async getItems(resetPagination) {
      if (this.filtro.empresaId == 0) {
        this.alertWarning('Debe elegir una Empresa.');
        return;
      }

      if (!this.filtro.diaALiquidar) {
        this.alertWarning('Debe elegir un día a liquidar.');
        return;
      }

      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      const filter = this.filtro;

      let canalesVenta = '0';
      if (filter.canalesVenta != null && filter.canalesVenta.length > 0)
        canalesVenta = filter.canalesVenta;

      try {
        var result = await http.get(
          'creditos/listcreditosparaliquidacioncomercio?empresaId=' +
            filter.empresaId +
            '&canalesVenta=' +
            canalesVenta +
            '&productoId=' +
            filter.productoId +
            '&grupoComercialId=' +
            filter.grupoComercialId +
            '&diaALiquidar=' +
            filter.diaALiquidar
        );

        this.records = result.list;
        this.selectedCreditos = [];

        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;
    },
    async getLiquidaciones(resetPagination) {
      if (this.filtroLiquidaciones.empresaId == 0) {
        this.alertWarning('Debe elegir una Empresa.');
        return;
      }

      if (this.filtroLiquidaciones.periodo.desde === undefined) {
        this.alertWarning('Debe elegir un periodo para la búsqueda.');
        return;
      }

      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtroLiquidaciones;

      try {
        var result = await http.get(
          'liquidaciones?empresaId=' +
            filter.empresaId +
            '&canalVentaId=' +
            filter.canalVentaId +
            '&grupoComercialId=' +
            filter.grupoComercialId +
            '&estadoId=' +
            filter.estadoId +
            '&fechaDesde=' +
            filter.periodo.desde +
            '&fechaHasta=' +
            filter.periodo.hasta +
            '&limit=' +
            this.paginationLiquidaciones.itemsPerPage +
            '&page=' +
            this.paginationLiquidaciones.page +
            '&sortby=' +
            this.paginationLiquidaciones.sortBy +
            '&descending=' +
            (this.paginationLiquidaciones.sortDesc.length > 0
              ? this.paginationLiquidaciones.sortDesc
              : 'false')
        );

        this.recordsLiquidaciones = result.list;
        this.selectedLiquidaciones = [];

        this.totalItemsLiquidaciones = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;
    },
    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get('productos/');

        this.productos = result.list.filter((x) =>
          x.tipoProductoDescripcion.toUpperCase().includes('DIRIGIDO')
        );

        this.productos.unshift({ id: 0, descripcion: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );

        this.empresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCajas() {
      this.loading = true;
      try {
        var result = await http.get('cajas');
        this.cajas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          'canalesventa/habilitadosparausuario?soloActivos=true&usuarioId=' +
            this.user.id
        );

        this.canalesVenta = result.list;

        this.canalesVenta.unshift({ id: 0, nombre: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadGruposComerciales() {
      this.loading = true;
      try {
        var result = await http.get(
          'gruposComerciales?limit=999&soloActivos=true'
        ); // traigo todas
        this.gruposComerciales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposEstadoLiquidacion() {
      this.loading = true;
      try {
        var result = await http.get('tiposestadoliquidacion?limit=999'); // traigo todas
        result.list.unshift({ id: 0, descripcion: '(Cualquiera)' });
        this.tiposEstadoLiquidacion = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async procesar() {
      const msg =
        '¿Confirma el Proceso de los ' +
        this.selectedCreditos.length +
        ' Créditos seleccionados?';

      if (confirm(msg)) {
        this.saving = true;

        try {
          this.filtro.lista = this.selectedCreditos;
          await http.post(
            'creditos/generarliquidacioncomercio',
            JSON.stringify({ parametros: this.filtro })
          );

          this.alertSuccess('Se generaron las Liquidaciones correctamente.');
          this.getItems(true);
        } catch (error) {
          this.alertError(error);
        }
        this.saving = false;
      }
    },
    async marcarNoPagar() {
      const msg =
        '¿Confirma que desea pasar los ' +
        this.selectedCreditos.length +
        ' créditos seleccionados a estado No Pagar?';

      if (confirm(msg)) {
        this.saving = true;

        try {
          var params = {};
          params.creditosId = this.selectedCreditos.map((x) => x.id);
          params.nuevoSubEstadoId = 104; // Activa No Pagar

          await http.post(
            'creditos/cambiarestadomasivo',
            JSON.stringify({ parametros: params })
          );

          await this.alertSuccess(
            'Se ha modificado el estado de los créditos.'
          );
          this.selectedCreditos = [];
          this.getItems(false);
        } catch (error) {
          // Error
          this.alertError(error);
        }
        this.saving = false;
      }
    },
    async anular() {
      const msg =
        '¿Confirma la anulacion de los ' +
        this.selectedLiquidaciones.length +
        ' Créditos seleccionados?';

      if (confirm(msg)) {
        this.saving = true;

        try {
          this.filtro.lista = this.selectedLiquidaciones;
          await http.post(
            'liquidaciones/anularliquidaciones',
            JSON.stringify({ parametros: this.filtro })
          );
          this.alertSuccess('Se realizaron las Anulaciones correctamente.');
          this.getLiquidaciones();
        } catch (error) {
          this.alertError(error);
        }
        this.saving = false;
      }
    },
    async confirmarPreliquidacion() {
      const msg =
        '¿Confirma el Pasaje a Definitiva de las ' +
        this.selectedLiquidaciones.length +
        ' Pre-Liquidaciones seleccionadas?';

      if (confirm(msg)) {
        this.saving = true;

        try {
          this.filtro.lista = this.selectedLiquidaciones;
          await http.post(
            'liquidaciones/confirmarpreliquidaciones',
            JSON.stringify({ parametros: this.filtro })
          );
          this.alertSuccess(
            'Las preliquidaciones fueron confirmadas correctamente.'
          );
          this.getLiquidaciones();
        } catch (error) {
          this.alertError(error);
        }
        this.saving = false;
      }
    },
    async imprimirDetalleLiquidacion(item) {
      let params = [];
      params.push({ LiquidacionId: item.id });
      await this.setReporteActivo({
        reporte: 'Reporte Detalle Liquidacion.trdp',
        params: params,
      });
      window.open('/report-viewer');
    },
    async procesarReporte() {
      var self = this;

      try {
        self.loading = true;

        let params = [];
        params.push({
          EmpresaId: this.filtroLiquidaciones.empresaId,
          CanalVentaId: this.filtroLiquidaciones.canalVentaId,
          GrupoComercialId: this.filtroLiquidaciones.grupoComercialId,
          EstadoId: this.filtroLiquidaciones.estadoId,
          FechaDesde: this.filtro.FechaDesde,
          FechaHasta: this.filtro.fechaHasta,
        });

        this.setReporteActivo({
          reporte: 'ReporteLiquidacionesGeneradas.trdp',
          params: params,
        });
        window.open('/report-viewer');
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    setDiaALiquidar() {
      this.filtro.diaALiquidar = new Date().getDay();
    },
  },
};
</script>
